import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAdmin } from '@/contexts/AdminContext';
import { Skeleton } from '@/components/ui/skeleton';

export const Route = createFileRoute('/_dashboard/admin/')({
  component: AdminPage,
});

function AdminPage() {
  const navigate = useNavigate();
  const { isSuperAdmin, isOrgAdmin, isLoading } = useAdmin();

  useEffect(() => {
    if (!isLoading) {
      if (isSuperAdmin) {
        navigate({ to: '/admin/superadmin', replace: true });
      } else if (isOrgAdmin) {
        navigate({ to: '/admin/org', replace: true });
      } else {
        navigate({ to: '/overview', replace: true });
      }
    }
  }, [isSuperAdmin, isOrgAdmin, isLoading, navigate]);

  return (
    <div className="space-y-4">
      <Skeleton className="h-8 w-48" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-32 w-full" />
        ))}
      </div>
    </div>
  );
}
